import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  TeamName,
  TeamNameExtensionSchema,
  validateTeamName,
} from './TeamName';

export const GitHubTeamNameExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitHubTeams_TeamName',
    component: TeamName,
    schema: TeamNameExtensionSchema,
    validation: validateTeamName,
  }),
);
